import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, X, Phone, ArrowRight } from 'lucide-react';
import { navLinks, company } from '../mock/mock';
import BrandMark from './BrandMark';

const Logo = () => (
  <Link to="/" className="flex items-center gap-2.5 group">
    <BrandMark size={38} />
    <div className="leading-tight">
      <div className="h-display text-[1.15rem] text-[var(--rs-green2)]">Residential Support</div>
    </div>
  </Link>
);

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header className={`sticky top-0 z-50 transition-all ${scrolled ? 'bg-[var(--rs-cream)]/90 backdrop-blur-md border-b border-[#E7E0D2]' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-4 flex items-center justify-between">
        <Logo />

        <nav className="hidden lg:flex items-center gap-7">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === '/'}
              className={({ isActive }) =>
                `text-[0.92rem] ul-link ${isActive ? 'text-[var(--rs-coral)] font-semibold' : 'text-[var(--rs-ink)] hover:text-[var(--rs-green)]'}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a href={`tel:${company.phone}`} className="flex items-center gap-2 text-sm text-[var(--rs-ink)] hover:text-[var(--rs-green)]">
            <Phone className="w-4 h-4" /> {company.phone}
          </a>
          <Link to="/contact" className="btn-primary text-sm">
            Contact us <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <button className="lg:hidden p-2 -mr-2 text-[var(--rs-ink)]" onClick={() => setOpen((o) => !o)} aria-label="menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[var(--rs-cream)] border-t border-[#E7E0D2]">
          <div className="px-5 py-4 flex flex-col gap-3">
            {navLinks.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.to === '/'} className={({ isActive }) => `py-2 text-base ${isActive ? 'text-[var(--rs-coral)] font-semibold' : 'text-[var(--rs-ink)]'}`}>
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact" className="btn-primary mt-2 justify-center">Contact us <ArrowRight className="w-4 h-4" /></Link>
            <a href={`tel:${company.phone}`} className="text-center text-sm pt-2 text-[var(--rs-green)]">{company.phone}</a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
